import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { ff } from '@atlassian/jira-feature-flagging';

export const getSourceByInviteFlow = (inviteFlow: string): string => {
	let source = inviteFlow;

	if (inviteFlow === 'mention') {
		source = 'mentionInEditor';
	} else if (inviteFlow === 'assignee') {
		source = 'assigneeField';
	}

	return source;
};

// we dont want to fire an exposure event, just want to know cohort
export const isInviteOnLinkInsertV3Enabled = (): boolean => {
	if (!ff('statsig-guard-invite-prompt-on-link-insert-v-3', false)) return false;

	const [expConfig] = UNSAFE_noExposureExp('invite_prompt_on_link_insert_v3');
	return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
